
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; once per page load.

var $1FOPM = parcelRequire("1FOPM");


var $jv1SC = parcelRequire("jv1SC");

let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
    // Warms the chunk behind ConversationAssistantConfigurerV2's lazy boundary so the first chat open
    // does not pay for the download. Harmless when V2 is off: the module is part of the eagerly loaded
    // graph in that case, so the import resolves from cache.
    (0, $1FOPM.importConversationAssistantUI)().catch(()=>{});
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("1FOPM", function(module, exports) {
// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the shared `lazy()` boundary
// (`ConversationAssistantUILazy`), the control arm's warm in `ConversationAssistantConfigurer` and
// the intent-time preload all go through here so they share one chunk identity.

const $9c885de35cb434ea$export$94646181d4dabf90 = ()=>(parcelRequire("dgGUB"));
module.exports["importConversationAssistantUI"] = $9c885de35cb434ea$export$94646181d4dabf90;

});

parcelRegister("dgGUB", function(module, exports) {

let $9a8e0e66c410db8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9a8e0e66c410db8b$var$load("ccAQf"),
    $9a8e0e66c410db8b$var$load("hUbK8"),
    $9a8e0e66c410db8b$var$load("kOEwh"),
    $9a8e0e66c410db8b$var$load("7fsAO"),
    $9a8e0e66c410db8b$var$load("53ySD"),
    $9a8e0e66c410db8b$var$load("fvc4H"),
    $9a8e0e66c410db8b$var$load("fwumK"),
    $9a8e0e66c410db8b$var$load("4yWZo"),
    $9a8e0e66c410db8b$var$load("7DJZY"),
    $9a8e0e66c410db8b$var$load("6Sqrl"),
    $9a8e0e66c410db8b$var$load("2WpPz"),
    $9a8e0e66c410db8b$var$load("7O8Z7"),
    $9a8e0e66c410db8b$var$load("16zlP"),
    $9a8e0e66c410db8b$var$load("j5uGx"),
    $9a8e0e66c410db8b$var$load("8ggEZ"),
    $9a8e0e66c410db8b$var$load("gXS72"),
    $9a8e0e66c410db8b$var$load("5fGvF"),
    $9a8e0e66c410db8b$var$load("TfSzW"),
    $9a8e0e66c410db8b$var$load("40Ugr"),
    $9a8e0e66c410db8b$var$load("9t4uk"),
    $9a8e0e66c410db8b$var$load("2la9m"),
    $9a8e0e66c410db8b$var$load("9pQri"),
    $9a8e0e66c410db8b$var$load("3zwpG"),
    $9a8e0e66c410db8b$var$load("iYzdG"),
    $9a8e0e66c410db8b$var$load("aMsb0"),
    $9a8e0e66c410db8b$var$load("2PXrC"),
    $9a8e0e66c410db8b$var$load("gcLWi"),
    $9a8e0e66c410db8b$var$load("fsgrC"),
    $9a8e0e66c410db8b$var$load("eqj21"),
    $9a8e0e66c410db8b$var$load("3oAU3"),
    $9a8e0e66c410db8b$var$load("2HGoF"),
    $9a8e0e66c410db8b$var$load("5J2OS"),
    $9a8e0e66c410db8b$var$load("ipIDQ"),
    $9a8e0e66c410db8b$var$load("gnocL"),
    $9a8e0e66c410db8b$var$load("agq8T"),
    $9a8e0e66c410db8b$var$load("8MPlE"),
    $9a8e0e66c410db8b$var$load("8exG0"),
    $9a8e0e66c410db8b$var$load("18viy"),
    $9a8e0e66c410db8b$var$load("89O2I"),
    $9a8e0e66c410db8b$var$load("d7ovg"),
    $9a8e0e66c410db8b$var$load("gDmxV"),
    $9a8e0e66c410db8b$var$load("ce05o"),
    $9a8e0e66c410db8b$var$load("6Vp6A"),
    $9a8e0e66c410db8b$var$load("4XoWv"),
    $9a8e0e66c410db8b$var$load("6wr18"),
    $9a8e0e66c410db8b$var$load("VXbA1"),
    $9a8e0e66c410db8b$var$load("7EorR"),
    $9a8e0e66c410db8b$var$load("ffEVr"),
    $9a8e0e66c410db8b$var$load("jT7h0"),
    $9a8e0e66c410db8b$var$load("gsQ9D"),
    $9a8e0e66c410db8b$var$load("dq8fV"),
    $9a8e0e66c410db8b$var$load("3PmUY"),
    $9a8e0e66c410db8b$var$load("bwLq7"),
    $9a8e0e66c410db8b$var$load("fH3TJ"),
    $9a8e0e66c410db8b$var$load("hhss7"),
    $9a8e0e66c410db8b$var$load("Wowvf"),
    $9a8e0e66c410db8b$var$load("2l8zo"),
    $9a8e0e66c410db8b$var$load("fHb94"),
    $9a8e0e66c410db8b$var$load("llPQO"),
    $9a8e0e66c410db8b$var$load("cKDij"),
    $9a8e0e66c410db8b$var$load("aAWLw"),
    $9a8e0e66c410db8b$var$load("9SEo9")
]).then(()=>parcelRequire('8RDrG'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("fpLEI"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("fpLEI", function(module, exports) {

let $b38e2838ae8d2c27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b38e2838ae8d2c27$var$load("ccAQf"),
    $b38e2838ae8d2c27$var$load("hUbK8"),
    $b38e2838ae8d2c27$var$load("19DCW"),
    $b38e2838ae8d2c27$var$load("kOEwh"),
    $b38e2838ae8d2c27$var$load("7fsAO"),
    $b38e2838ae8d2c27$var$load("53ySD"),
    $b38e2838ae8d2c27$var$load("fvc4H"),
    $b38e2838ae8d2c27$var$load("4yWZo"),
    $b38e2838ae8d2c27$var$load("7DJZY"),
    $b38e2838ae8d2c27$var$load("2WpPz"),
    $b38e2838ae8d2c27$var$load("7O8Z7"),
    $b38e2838ae8d2c27$var$load("16zlP"),
    $b38e2838ae8d2c27$var$load("j5uGx"),
    $b38e2838ae8d2c27$var$load("8ggEZ"),
    $b38e2838ae8d2c27$var$load("gXS72"),
    $b38e2838ae8d2c27$var$load("5fGvF"),
    $b38e2838ae8d2c27$var$load("TfSzW"),
    $b38e2838ae8d2c27$var$load("40Ugr"),
    $b38e2838ae8d2c27$var$load("9t4uk"),
    $b38e2838ae8d2c27$var$load("2la9m"),
    $b38e2838ae8d2c27$var$load("9pQri"),
    $b38e2838ae8d2c27$var$load("3zwpG"),
    $b38e2838ae8d2c27$var$load("iYzdG"),
    $b38e2838ae8d2c27$var$load("aMsb0"),
    $b38e2838ae8d2c27$var$load("2PXrC"),
    $b38e2838ae8d2c27$var$load("gcLWi"),
    $b38e2838ae8d2c27$var$load("fsgrC"),
    $b38e2838ae8d2c27$var$load("eqj21"),
    $b38e2838ae8d2c27$var$load("3oAU3"),
    $b38e2838ae8d2c27$var$load("2HGoF"),
    $b38e2838ae8d2c27$var$load("5J2OS"),
    $b38e2838ae8d2c27$var$load("5hXCh"),
    $b38e2838ae8d2c27$var$load("ipIDQ"),
    $b38e2838ae8d2c27$var$load("gnocL"),
    $b38e2838ae8d2c27$var$load("agq8T"),
    $b38e2838ae8d2c27$var$load("8MPlE"),
    $b38e2838ae8d2c27$var$load("8exG0"),
    $b38e2838ae8d2c27$var$load("VXbA1"),
    $b38e2838ae8d2c27$var$load("jT7h0"),
    $b38e2838ae8d2c27$var$load("gsQ9D"),
    $b38e2838ae8d2c27$var$load("dq8fV"),
    $b38e2838ae8d2c27$var$load("bwLq7"),
    $b38e2838ae8d2c27$var$load("fH3TJ"),
    $b38e2838ae8d2c27$var$load("2l8zo"),
    $b38e2838ae8d2c27$var$load("cKDij"),
    $b38e2838ae8d2c27$var$load("18viy"),
    $b38e2838ae8d2c27$var$load("89O2I"),
    $b38e2838ae8d2c27$var$load("d7ovg"),
    $b38e2838ae8d2c27$var$load("fHb94"),
    $b38e2838ae8d2c27$var$load("llPQO"),
    $b38e2838ae8d2c27$var$load("6wr18"),
    $b38e2838ae8d2c27$var$load("gDmxV"),
    $b38e2838ae8d2c27$var$load("4XoWv"),
    $b38e2838ae8d2c27$var$load("ffEVr"),
    $b38e2838ae8d2c27$var$load("Wowvf"),
    $b38e2838ae8d2c27$var$load("6Vp6A"),
    $b38e2838ae8d2c27$var$load("3PmUY"),
    $b38e2838ae8d2c27$var$load("hhss7"),
    $b38e2838ae8d2c27$var$load("7EorR"),
    $b38e2838ae8d2c27$var$load("ce05o"),
    $b38e2838ae8d2c27$var$load("aAWLw"),
    $b38e2838ae8d2c27$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.c9b6c9b0.js.map
